import React from 'react'
import ReactDOM from 'react-dom/client'
import { App } from './App'
import "./styles/theme.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env[`VITE_APP_ADMIN_SENTRY_DSN`],
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }
    ),
    Sentry.httpClientIntegration({
      failedRequestStatusCodes: [
        [400, 599]  // This range includes all 4xx and 5xx codes
      ]
    })
  ],
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  sendDefaultPii: true
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
) 